import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import BackstockSimulatorContent from '../../backstockSimulator/components/BackstockSimulatorContent';
import {
  getPackSimulatorFromSearch,
  setPackSimulatorInSearch,
  type PackSimulator,
} from '../utils/packSimulatorQueryParams';
import CaseSimulatorContent from './CaseSimulatorContent';

type PackStockSimulatorsContentProps = {
  stateCode?: string | null;
  storeId: string;
};

const PackStockSimulatorsContent: React.FC<PackStockSimulatorsContentProps> = ({
  stateCode,
  storeId,
}) => {
  const [downloadActionContainer, setDownloadActionContainer] = React.useState<HTMLDivElement | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const activeSimulator = React.useMemo(
    () => getPackSimulatorFromSearch(location.search),
    [location.search],
  );

  const handleSimulatorChange = React.useCallback((_: React.SyntheticEvent, value: PackSimulator) => {
    navigate(
      {
        pathname: location.pathname,
        search: `?${setPackSimulatorInSearch(location.search, value)}`,
      },
      { replace: true },
    );
  }, [location.pathname, location.search, navigate]);

  return (
    <Box>
      <Box
        sx={{
          alignItems: 'center',
          bgcolor: 'background.paper',
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1,
          justifyContent: 'space-between',
          px: 0,
          position: 'sticky',
          top: 0,
          zIndex: 2,
        }}
      >
        <Tabs
          value={activeSimulator}
          onChange={handleSimulatorChange}
          aria-label="Pack simulators"
          sx={{
            minWidth: 0,
            minHeight: 56,
            '& .MuiTab-root': {
              minHeight: 56,
            },
            '& .MuiTab-root.Mui-selected': {
              fontWeight: 600,
            },
          }}
        >
          <Tab value="case" label="CASE SIMULATOR" />
          <Tab value="backstock" label="BACKSTOCK SIMULATOR" />
        </Tabs>
        <Box
          ref={setDownloadActionContainer}
          sx={{ alignItems: 'center', display: 'flex', flexShrink: 0, minHeight: 56, ml: 'auto', pl: 2, pr: 2 }}
        />
      </Box>

      {activeSimulator === 'case' ? (
        <CaseSimulatorContent downloadActionContainer={downloadActionContainer} storeId={storeId} />
      ) : (
        <BackstockSimulatorContent storeId={storeId} stateCode={stateCode} />
      )}
    </Box>
  );
};

export default PackStockSimulatorsContent;
